module.exports = __webpack_public_path__ + "media/images/meeting_points/lesson-92fdbe80c8495eecab685b545d0dec86.png";